























require("./CardItem/CardItem.vue");

import CardsComponent from "./CardsComponent";
export default CardsComponent;
